"use client";

import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Spinner,
  Badge,
  Modal,
} from "react-bootstrap";
import api from "../../services/api";
import Swal from "sweetalert2";

const StorePendingPayments = () => {
  const [payments, setPayments] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [
    selectedPayment,
    setSelectedPayment,
  ] = useState(null);

  const [action, setAction] =
    useState(null);

  const [
    processing,
    setProcessing,
  ] = useState(false);

  const fetchPayments = async () => {
    setLoading(true);

    try {
      const { data } =
        await api.get(
          "/payments/store/pending"
        );

      setPayments(
        Array.isArray(data)
          ? data
          : data.items || []
      );
    } catch {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text:
          "دریافت پرداخت‌های منتظر تأیید انجام نشد.",
        confirmButtonText:
          "باشه",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const executeAction =
    async () => {
      if (
        !selectedPayment ||
        !action
      ) {
        return;
      }

      const code =
        selectedPayment.code ||
        selectedPayment.paymentCode;

      setProcessing(true);

      try {
        await api.post(
          `/payments/${code}/${action}`
        );

        Swal.fire({
          icon: "success",
          title: "عملیات انجام شد",
          text:
            action === "confirm"
              ? "پرداخت تأیید شد."
              : "پرداخت رد شد.",
          confirmButtonText:
            "باشه",
        });

        setSelectedPayment(null);
        setAction(null);

        await fetchPayments();
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "خطا",
          text:
            err?.response?.data?.message ||
            "عملیات انجام نشد.",
          confirmButtonText:
            "باشه",
        });
      } finally {
        setProcessing(false);
      }
    };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <Card className="border-0 rounded-3">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="mb-1">
                پرداخت‌های در انتظار تأیید
              </h3>

              <span className="text-secondary">
                پرداخت‌های کارت‌به‌کارت و نقدی
              </span>
            </div>

            <Badge bg="warning">
              {payments.length}
            </Badge>
          </div>

          <Table
            striped
            hover
            responsive
            className="align-middle"
          >
            <thead>
              <tr>
                <th>کد پرداخت</th>
                <th>کد سفارش</th>
                <th>مبلغ</th>
                <th>روش</th>
                <th>شماره پیگیری</th>
                <th>عملیات</th>
              </tr>
            </thead>

            <tbody>
              {payments.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center"
                  >
                    پرداخت منتظر تأییدی وجود ندارد.
                  </td>
                </tr>
              ) : (
                payments.map(
                  (payment) => {
                    const paymentCode =
                      payment.code ||
                      payment.paymentCode;

                    return (
                      <tr
                        key={
                          paymentCode
                        }
                      >
                        <td>
                          {paymentCode}
                        </td>

                        <td>
                          {payment.orderCode ||
                            payment.order?.code ||
                            "-"}
                        </td>

                        <td>
                          {Number(
                            payment.amount ||
                              0
                          ).toLocaleString(
                            "fa-IR"
                          )}{" "}
                          تومان
                        </td>

                        <td>
                          <Badge bg="secondary">
                            {payment.method ||
                              "-"}
                          </Badge>
                        </td>

                        <td>
                          {payment.referenceNumber ||
                            "-"}
                        </td>

                        <td>
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              variant="success"
                              onClick={() => {
                                setSelectedPayment(
                                  payment
                                );
                                setAction(
                                  "confirm"
                                );
                              }}
                            >
                              تأیید
                            </Button>

                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => {
                                setSelectedPayment(
                                  payment
                                );
                                setAction(
                                  "reject"
                                );
                              }}
                            >
                              رد
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                )
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Modal
        show={!!selectedPayment}
        onHide={() => {
          if (!processing) {
            setSelectedPayment(null);
            setAction(null);
          }
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            تأیید عملیات
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {action === "confirm"
            ? "آیا از تأیید این پرداخت اطمینان دارید؟"
            : "آیا از رد این پرداخت اطمینان دارید؟"}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setSelectedPayment(null);
              setAction(null);
            }}
            disabled={processing}
          >
            انصراف
          </Button>

          <Button
            variant={
              action === "confirm"
                ? "success"
                : "danger"
            }
            onClick={
              executeAction
            }
            disabled={processing}
          >
            {processing ? (
              <Spinner
                animation="border"
                size="sm"
              />
            ) : action ===
              "confirm" ? (
              "تأیید پرداخت"
            ) : (
              "رد پرداخت"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StorePendingPayments;